import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CustomPanel, CustomTabView, PageHeader } from '../../../../components'
import { TabPanel } from 'primereact/tabview'
import DevolucaoParcialAssociada from '../DevolucaoParcialAssociada/DevolucaoParcialAssociada'
import DevolucaoTotalAssociada from '../DevolucaoTotalAssociada/DevolucaoTotalAssociada'
import SobraAssociada from '../SobraAssociada/SobraAssociada'

function OcorrenciasAssociadas({ history, dispatch, selectedTp }) {
  // Vars
  const { ordem } = history.location.state
  // Hooks

  // Events

  // Helpers

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Ocorrências
        <strong> &nbsp; Associadas</strong>
        &nbsp; - Ordem Selecionada:
        <strong>&nbsp; {ordem.descricao}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          <CustomTabView activeIndex={0}>
            <TabPanel header="Sobras" disabled={false}>
              <SobraAssociada
                tpId={selectedTp}
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
              />
            </TabPanel>
            <TabPanel header="Devolução Parcial" disabled={false}>
              <DevolucaoParcialAssociada
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
                tpId={selectedTp}
              />
            </TabPanel>
            <TabPanel header="Devolução Total" disabled={false}>
              <DevolucaoTotalAssociada
                ordemColetaId={ordem.id}
                companyId={ordem.company_id}
                tpId={selectedTp}
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(OcorrenciasAssociadas))
